if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.swiperInstance = null; // To store the Swiper instance
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const activeMediaId = this.openedBy.getAttribute('data-media-id');
        const activeMediaElement = this.querySelector(`[data-media-id="${activeMediaId}"]`);

        if (!activeMediaElement) return;

        const mediaIndex = Array.from(this.querySelectorAll('.swiper-slide')).findIndex(
          (slide) => slide.contains(activeMediaElement)
        );

        if (this.swiperInstance && mediaIndex !== -1) {
          // Update Swiper to show the active slide
          this.swiperInstance.slideTo(mediaIndex, 0); // No transition
        }

        // Mark the active media
        this.querySelectorAll(`[data-media-id]`).forEach((element) => {
          element.classList.remove('active');
        });

        activeMediaElement.classList.add('active');
        activeMediaElement.scrollIntoView();
      }
    }
  );
}

document.addEventListener('DOMContentLoaded', () => {
  // Initialize Swiper for product modal
  const productModalSwiper = new Swiper('.product-modal-swiper-container', {
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    slidesPerView: 1,
    spaceBetween: 10,
  });

  // Attach Swiper instance to the modal
  const modalElement = document.querySelector('product-modal');
  if (modalElement) {
    modalElement.swiperInstance = productModalSwiper;
  }
});
